const FKControlMenuDivider = <template>
  <@divider class="form-kit__control-menu-divider" />
</template>;

export default FKControlMenuDivider;
